import Swiper from 'swiper'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/a11y'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
const el = document.querySelector('.module--timeline .swiper')

const swiper = new Swiper(el, {
  modules: [A11y, Navigation, Pagination],
  slidesPerView: 1,
  spaceBetween: 16 * 2,
  speed: 600,
  loop: true,
  breakpoints: {
    768: {
      spaceBetween: 40,
      slidesPerView: 'auto',
    }
  },
  a11y: {
    enabled: true
  },
  navigation: {
    nextEl: '.swiper-button-next'
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
})